module.exports = __webpack_public_path__ + "img/edelstahlarbeiten_250.646fd4dc.jpg";